import styled from "@emotion/styled";
import { InputBaseProps, TextField } from "@mui/material";
import { ReactNode, useState } from "react";
import colors from "theme/colors";
import { sharedColors } from "ui/theme/colors";

const Asterisk = styled.span<{ $marginBottom?: number; $color: string }>`
  color: ${(p) => p.$color};
   margin-bottom: ${(p) => (p.$marginBottom ? `${p.$marginBottom}px` : "0px")};
  width: 4px;
  margin-top: 25px;
`

const StyledTextField = styled(TextField) <{ multiline: boolean }>`
  .MuiInputBase-root {
    height:${(props) => props.multiline ? 120 : 49}px;
    caret-color: ${sharedColors.blue};
  }
  .MuiFormHelperText-root {
    font-size: 14px;
    color: ${sharedColors.darkRed};
  }
  ${(props) => props.theme.breakpoints.up("md")} {
    .MuiInputBase-root {
    height:${(props) => props.multiline ? 120 : 46}px;
    }
    .MuiFormHelperText-root {
      font-size: 12px;
      line-height: 1;
    }
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    .MuiInputBase-root {
        height:${(props) => props.multiline ? 120 : 56}px;
    }
    .MuiFormHelperText-root {
      font-size: 12px;
      line-height: 1;
    }
  }

  ${(props) => props.theme.breakpoints.up("xl")} {
    .MuiInputBase-root {
            height:${(props) => props.multiline ? 120 : 69}px;
      // height: 69px;
    }
    .MuiFormHelperText-root {
      font-size: 14px;
    }
  }
  label {
    margin-top: 8px;
    color: black;
  }
`
const StyledInputWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 5px;
`

type FormInputProps = {
  field: object
  error?: string | undefined
  placeholder?: string
  type: string
  required?: boolean
  inputProps?: InputBaseProps
  fullWidth?: boolean
  multiline?: boolean
  rows?: number
  textColor?: string
  onFocus?: () => void
  label?: ReactNode
  withAsterisk?: boolean
}

function FormInputCharge({
  field,
  error,
  placeholder = "",
  type = "text",
  required = false,
  inputProps,
  fullWidth = false,
  multiline = false,
  rows = 1,
  textColor = "black",
  onFocus,
  label,
  withAsterisk = true
}: FormInputProps) {
  const [focused, setFocused] = useState(false)
  return (
    <StyledInputWrapper>
      {withAsterisk &&
        <Asterisk
          $marginBottom={28}
          $color={error ? colors.darkRed : colors.blue}
        >
          *
        </Asterisk>
      }
      <StyledTextField
        {...field}
        // placeholder={placeholder}
        helperText={error}
        variant="standard"
        // error={error ? true : false}
        fullWidth={fullWidth}
        type={type}
        multiline={multiline}
        rows={rows}
        InputProps={{
          ...inputProps,
          sx: {
            color: textColor
          }
        }}
        label={label}
        onFocus={() => {
          setFocused(true)
          if (onFocus) {
            onFocus()
          }
        }
        }
        onBlur={() => setFocused(false)}
        aria-describedby={error}
      />

    </StyledInputWrapper>
  )
}

export default FormInputCharge
